export default __webpack_public_path__ + "static/media/Ch3a.1715b606.gif";